// extracted by mini-css-extract-plugin
module.exports = {"button":"CartButton_button__3WDTa","icon":"CartButton_icon__2mrF5","badge":"CartButton_badge__30PA_","bump":"CartButton_bump__3LoZ1"};